import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Building } from './../../model/building';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Company } from '../../model/company';
import { Property } from '../../model/property';
import { catchError, map } from 'rxjs/operators';
import { AutoCompleteSelectionItem, IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-remote.component';
import { DhMarketAreaOptions } from '../../../letting/model/platform-options';
import { BuildingSpace } from '../../model/building-space';

@Injectable()
export class BuildingSpaceService extends DataService<BuildingSpace> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private _messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, config, _messageService, BuildingSpace, progressBar, 'building-space');
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem> {
    return this.client.get<any>(`${this.endpoint}/selectionItem/${id}`).pipe(
      map(item => new AutoCompleteSelectionItem(item.name, item.id, item, item.shortName)),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  getSelection(filter: string, options?: any, page?: number): Observable<AutoCompleteSelectionItem[]> {
    let queryArgs = {
      filter: filter,
      maxItems: 20,
    };
    if (options) queryArgs['options'] = options;
    if (page && page > 0) queryArgs['page'] = page;

    return this.client.post<any[]>(`${this.endpoint}/selection`, queryArgs).pipe(
      map(data => data.map(item => new AutoCompleteSelectionItem(item.name, item.id, item, item.shortName))),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  protected createModel(modelData: any): BuildingSpace {
    try {
      return new BuildingSpace(modelData);
    } catch (e) {
      console.log(e);
      throw new Error('Invalid data format.');
    }
  }
}
